module.exports = __webpack_public_path__ + "img/Fedor Kornachev, Co-President, Schulich Finance Association.c29a68a7.webp";